import { WIDGET_NAME } from './index';

export const wrapperEvent = (name, detail) =>
  new CustomEvent(`${WIDGET_NAME}:${name}`, {
    bubbles: true,
    composed: true,
    detail
  });
